import type { FaireProductEntity } from "../../entity_types/product";

export const p_2m2sh6d24u: FaireProductEntity = {
  token: "p_2m2sh6d24u",
  type: "product",
  name: "Shampoo Bars",
  brandToken: "b_ec3gk747v4",
  brandName: "Golden Banks Soapery",
  imageUrl:
    "https://cdn.faire.com/fastly/71b5e564448dca6b1eb73e4d6387e3afdd3fd443165ef6b3b0b23b6c97b6495d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa239b19d9c9109f42098a7a121ea2c6e0ff4266169fc807a1fc7463e49f8c74.jpeg",
    "https://cdn.faire.com/fastly/6777e41ca434b40e3cf602a0b51fac87b784d7b0721bf4348ecf3cbae6f9ec37.jpeg",
    "https://cdn.faire.com/fastly/391ddcb427b8e29f3a626b2d678bf1e48093dcafd298708c827782aa68f10584.jpeg",
  ],
  priceDollars: 4.8,
  description:
    "\nOur shampoo bars feature a gentle formula that lathers beautifully and is suitable for most hair types. Shampoo bars are the ingredients of a traditional shampoo -- just without the water. They are a better alternative to large plastic bottles, and are convenient for travel. If stored properly & allowed to air dry between uses, a  bar can last for over 40 washes. Our formula has no sulfates, phthalates or parabens & is PH balanced. Each bar is approximately 3 oz. ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:34.166Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
